/*
  Parse geo point from <string>"(lat,lon)" to array<float>
*/
export const parseGeoPoint = (pointRaw = '') => {
  if (/^\d+(?:\.\d+)?\s*,\s*\d+(?:\.\d+)?$/.test(pointRaw)) {
    const parsed = pointRaw
      .replace(/[()\s]*/, '')
      .split(',')
      .map(coord => parseFloat(coord))

    return parsed
  }

  return []
}

/*
  Create balloon markup
*/
export const makeBalloonContent = ({ name = '', builder = '', photo = '', link = '', text = '' }) => {
  return `
  <div class="developer-map-balloon">
    <div class="developer-map-balloon__content">
      <div class="developer-map-balloon__info">
        <h3 class="developer-map-balloon__title">${ name }</h3>
        <p class="developer-map-balloon__developer">${ builder }</p>
      </div>
      <div class="developer-map-balloon__photo">
        <a href="${ link }" class="developers-map-lightbox" target="_blank">
          <img src="${ decodeURIComponent(photo) }" alt="${ name }" />
        </a>
      </div>

      <div class="developer-map-balloon__text">${ text }</div>
    </div>
    <a class="developer-map-balloon__link" href="${ link }" target="_blank">${ name }</a>
  </div>`
}

export const makePlacemarkIcon = ({ map_icon = null }) => {
  return map_icon
}